import { Chart, ChartTitle, ChartLegend, ChartTooltip, ChartSeries, ChartSeriesItem, ChartSeriesLabels } from '@progress/kendo-react-charts';
import { useApiTrigger } from "../../hooks/useApiTrigger";
import { forwardRef, useImperativeHandle } from 'react';

const tooltipRender = props => {
    if (props.point) {
        return props.point.dataItem.category;
    }
};

const FunnelChart = forwardRef(({ data, filters, returnData }, ref) => {
    const { dto } = useApiTrigger(data, filters);

    const getData = () => {
        const fileName = data.accion || 'Reporte_Grafica';
        returnData(dto, fileName);
    };

    useImperativeHandle(ref, () => ({
        exportChartData: getData,
    }));

    return (
        <Chart style={{ width: "100%", height: "100%" }}>
            <ChartTitle text={data.accion} />
            <ChartLegend position="top" orientation="horizontal" />
            <ChartSeries>
                <ChartSeriesItem
                    type="funnel"
                    data={dto}
                    categoryField="category"
                    field="value"
                    colorField="color"
                    dynamicSlope={true}
                >
                    <ChartSeriesLabels color="white" background="none" format="N0" />
                </ChartSeriesItem>
            </ChartSeries>
            <ChartTooltip render={tooltipRender} />
        </Chart>
    );
})
export default FunnelChart;